<generic-page
  *ngIf="_appService.CoreCommonLiterals"
  [title]="_appService.CoreCommonLiterals?.ManageDashboards"
  [errorMessage]="_errorBackEnd"
  [goBackOnCancel]="false"
  [isGeneric]="true">

  <table-cmp
    rememberFilters="true"
    [masterDataEntityContent]="_masterDataEntityContent"
    [enablePagination]="true"
    [showTotalRowCount]="true"
    [rowsPerPage]="10"
    editRoute="dashboard/edit/"
    addRoute="dashboard/add/"
    (onRemove)="confirmOnRemove($event)"
    (onCustom1)="cloneDashboard($event)"
  ></table-cmp>
  <button id="table-btn-back" class="btn btn-primary mr-2" (click)="goBack(goBackRoute)"><i class="fa-solid fa-reply" style="font-weight: 900; font-family: 'Font Awesome 5 Free';"></i> {{_appService.CoreCommonLiterals.GoBack}}</button>
</generic-page>

<modal-confirm #confirmRemove [title]="_appService.CoreCommonLiterals?.Delete + ' ' + _appService.CoreCommonLiterals?.Dashboard"
  [content]="_appService.CoreCommonLiterals?.SureYouWantToContinue"
  [(errorMessage)]="_errorMessage"
  [submitButtonText]="_appService.CoreCommonLiterals?.ButtonConfirm"
  (submit)="onConfirmRemove()"
  [closeButtonText]="_appService.CoreCommonLiterals?.ButtonCancel">
</modal-confirm>

<modal #modalCloneDashboard
  id="edit-modal"
  modalClass="modal-lg"
  [(errorMessage)]="_errorMessage"
  [submitButtonText]="_appService.CoreCommonLiterals?.ButtonSave"
  (onSubmit)="saveDashboard(formElement)"
  [closeButtonText]="_appService.CoreCommonLiterals?.ButtonCancel"
  >
  <modal-header>{{_appService.CoreCommonLiterals?.CloneDashboard}}</modal-header>
  <modal-content>
    <form #formElement="ngForm">
      <div *ngIf="_pageStatus !== 0">
        <div class="form-group">
          <label for="description" class="mt-3">{{_appService.CoreCommonLiterals?.Description}}</label>
          <div class="input-group">
            <input
            type="text"
            id="description"
            class="form-control"
            name="description"
            (click)="_errorMessage = ''"
            [(ngModel)]="_description"
            #address="ngModel"
            required/>
          </div>
        </div>
        <div class="form-group" *ngIf="_parameters?.ClientID === 0">
          <custom-select
            [(ngModel)]="cloneParams.cloneDestination" 
            [bordered]="true"
            [keepValueIfExistsInNewList]="true"
            [labelText]="_appService.CoreCommonLiterals?.DashboardCloneDestination" 
            name="cloneDestination"
            id="cloneDestination"
            [(sourceList)]="cloneDestinationsList">
          </custom-select>
        </div>
        <div class="form-group" *ngIf="_parameters?.ClientID === 0">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="clonePermissions" name="clonePermissions" [(ngModel)]="cloneParams.clonePermissions">
            <label class="custom-control-label" for="clonePermissions">{{_appService.CoreCommonLiterals?.DashboardClonePermissions}}</label>
          </div>
        </div>
      </div>
    </form>
    <div class="text-center" *ngIf="_pageStatus === 0">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
    </div>
  </modal-content>
</modal>
